export default __webpack_public_path__ + "b78dfd7a4710819cd696c3dcbfb418be.webp";